import * as types from '../mutation-types'
import { api } from '@/api'
import { serviceDic } from '@/util/minxins/serviceDic'
import Vue from 'vue'
import { Store } from 'vuex'
//通用模块状态控制
const commModule = {
  state: {
    deptTree: {
      data: [],
      tmpData: {
        OPPEIN: [],
        AGENT: [],
        OTHER: [],
      },
      curType: 'OPPEIN',
      props: {
        label: 'name',
        children: 'children',
      },
      loading: false,
    },
    serviceDic: {},
    dicFlags: {}, //由于请求字典可能会有一直赋值不到的时候，可能会不停请求接口，这里设置一个节流锁,每个页面同一个字段最多调三次
    brandCategory: {
      list: [],
      tree: [],
      props: {
        label: 'name',
        children: 'children',
        disabled: 'disabled',
        value: 'code',
      },
      loading: false,
    },
    dict: {
      params: {},
      list: [],
    },
    orgLists: {
      //部门管理树
      agent: [],
      oppein: [],
      other: [],
    },
  },

  //激发事件改变state
  mutations: {
    setDepartmant(state, option) {
      // 'option.orgType' 会传入 'ACC', 这里需要把他认为是'OPPEIN'
      let orgType = option.orgType
      if (orgType === 'ACC') {
        orgType = 'OPPEIN'
      }
      for (let key in state.orgLists) {
        if (orgType && key === String(orgType).toLowerCase()) {
          state.orgLists[key] = option.list
        }
      }
    },
    setServiceDic(state, option) {
      state.serviceDic = Object.assign({}, state.serviceDic, option)
    },
    setDicFlags(state, option) {
      state.dicFlags = option
    },
    deptTreeLoadingChange(state, n) {
      state.deptTree.loading = n === undefined ? !state.deptTree.loading : !!n
    },
    deptTreeDataChange(state, n) {
      const childrenHandle = (arr) => {
        if (Array.isArray(arr) && arr.length) {
          arr.forEach((list) => {
            if (!list.children.length) {
              list.children = undefined
            } else {
              childrenHandle(list.children)
            }
          })
        } else {
          arr = []
        }
      }

      childrenHandle(n.data)

      state.deptTree.data = n.data || []
      state.deptTree.tmpData[n.type] = n.data || []
      state.deptTree.curType = n.type
    },

    brandCategoryLoadingChange(state, n) {
      state.brandCategory.loading = n === undefined ? !state.brandCategory.loading : !!n
    },
    brandCategoryDataChange(state, n) {
      let tmp = n || []
      state.brandCategory.tree = tmp.map((v) => {
        v.children.forEach((x) => {
          delete x.children
        })
        return v
      })
      state.brandCategory.list = Array.prototype.concat.apply(
        [],
        tmp.map((v) =>
          v.children.map((x) => {
            return {
              brand: v.code,
              category: x.code,
            }
          })
        )
      )
    },
    commonMutationsGetDictList(state, obj) {
      state.dict.params = obj.params
      state.dict.list = obj.list
    },
  },

  // 异步操作拿远程数据,然后提交事件
  actions: {
    async setAllChannel({ commit, state }, params = {}) {
      let setDisabled = (tree, list = []) => {
        let arr = list
        if (Array.isArray(tree)) {
          tree.forEach((i) => {
            if (i.channelCode && i.channelCode) {
              arr.push(i)
            }
            if (!i.channelCode) {
              i.disabled = true
            }
            if (Array.isArray(i.children) && i.children.length > 0) {
              setDisabled(i.children, arr)
            }
          })
        }
        return {
          tree,
          list: arr,
        }
      }
      const setCascaderData = (tree) => {
        tree.forEach((i) => {
          if (Array.isArray(i.children) && i.children.length > 0) {
            setCascaderData(i.children)
          } else {
            delete i.children
          }
        })
        return tree
      }
      try {
        let res = await api.communication.getDictChannelHierarchyConfigureTreeList(params)
        if (res.status && Array.isArray(res.data)) {
          let render = {}
          render['bussiness-channels-all'] = setCascaderData(JSON.parse(JSON.stringify(res.data)))
          let { tree, list } = setDisabled(res.data)
          if (Array.isArray(tree) && tree.length > 0) {
            render['bussiness-channels'] = tree
          }
          if (Array.isArray(list) && list.length > 0) {
            render['unableChannelList'] = list
          }
          commit('setServiceDic', render)
        }
      } catch (err) {
        console.log('获取线别异常', err)
      }
    },
    async setAllLiners({ commit, state }, params = {}) {
      let fun = (arr, list = []) => {
        let theList = list
        if (Array.isArray(arr)) {
          arr.forEach((i) => {
            theList.push(i)
            if (Array.isArray(i.children) && i.children.length) {
              fun(i.children, theList)
            }
          })
        }
        return theList
      }
      try {
        let res = await api.line.getLineConfigureTreeList(params)
        if (res.status && Array.isArray(res.data)) {
          if (!Object.keys(params).length) {
            commit('setServiceDic', {
              linesTree: res.data,
            })
            commit('setServiceDic', {
              lines: fun(res.data),
            })
          }
          return JSON.parse(JSON.stringify(res.data))
        }
      } catch (err) {
        console.log('获取线别异常', err)
      }
    },
    setCommonServiceDic({ commit, state }, params) {
      if (params.ditTypes) {
        let types = params.ditTypes.split(',')
        let objs = Object.assign({}, state.dicFlags)
        types = types.filter((i) => {
          return !objs[i] || objs[i] < 4
        })
        if (types.length < 1) {
          return
        }
        types.forEach((i) => {
          if (!objs[i]) {
            objs[i] = 1
          } else {
            objs[i] += 1
          }
        })
        commit('setDicFlags', objs)
        api.dict
          .getDitTypeListByDitTypes({
            typeList: params.ditTypes.split(','),
          })
          .then((res) => {
            if (res.status) {
              let obj = {}
              serviceDic.forEach((i) => {
                if (res.data && res.data[i.ditType]) {
                  obj[i.key] = Array.isArray(res.data[i.ditType]) ? res.data[i.ditType] : []
                }
              })
              commit('setServiceDic', obj)
            }
          })
      }
    },
    async getMarketClassifyConfigureList({ commit, state }, options = {}) {
      //执行查询
      let params = Object.assign({}, options)
      try {
        let res = await api.communication.getMarketClassifyConfigureList(params)
        if (res && res.status && Array.isArray(res.data)) {
          commit('setServiceDic', {
            classifys: res.data,
          })
        }
      } catch (err) {
        console.log(err, '获取事业线失败')
      }
    },
    loadDeptTree({ commit, state }, condition) {
      //执行查询
      let type = condition ? condition.type || 'OPPEIN' : 'OPPEIN'
      let parentId = condition ? condition.parentId || 'Root' : 'Root'
      commit('deptTreeDataChange', {
        data: [],
        type: type,
      })
      commit('deptTreeLoadingChange', true)
      api.department
        .tree({
          parentId: parentId,
          orgType: type,
        })
        .then((res) => {
          commit('deptTreeLoadingChange', false)
          commit('deptTreeDataChange', {
            data: res.data,
            type: type,
          })
        })
    },
    loadBrandCategory({ commit, state }) {
      //执行查询
      if (state.brandCategory.tree.length === 0 && state.brandCategory.loading === false) {
        commit('brandCategoryLoadingChange', true)
        api.system.brandTree().then((res) => {
          commit('brandCategoryLoadingChange', false)
          commit('brandCategoryDataChange', res.data)
        })
      }
    },
    getDepartmentList({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        api.department
          .getDepartmentTreeList(params)
          .then((res) => {
            if (res.status && Array.isArray(res.data)) {
              commit('setDepartmant', {
                orgType: params.orgType,
                list: res.data,
              })
            }
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getAccDepartmentList({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        api.department
          .getAccDepartmentTreeList(params)
          .then((res) => {
            if (res.status && Array.isArray(res.data)) {
              commit('setDepartmant', {
                orgType: params.orgType,
                list: res.data,
              })
            }
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },

  //频繁通用计算
  getters: {
    commonServiceDictList(state) {
      return function (type) {
        if (type) {
          return state.serviceDic[type] || []
        }
      }
    },
  },
}

export default commModule
